import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const leadService = {
  getAll,
  getStats,
  get,
  create,
  update,
  remove,
  convert,
  assign,
}

export function getAll(filter = {}) {
  const params = {}
  if (filter.page) params.page = filter.page
  if (filter.size) params.size = filter.size
  if (filter.search) params.search = filter.search
  if (filter.status) params.status = filter.status
  if (filter.source) params.source = filter.source
  if (filter.assignedTo) params.assigned_to = filter.assignedTo
  return apiHelper(API_URL).get('/leads', { params })
}

export function getStats() {
  return apiHelper(API_URL).get('/leads/stats')
}

export function get(uuid) {
  return apiHelper(API_URL).get(`/leads/${uuid}`)
}

export function create(payload) {
  return apiHelper(API_URL).post('/leads', payload)
}

export function update(uuid, payload) {
  return apiHelper(API_URL).put(`/leads/${uuid}`, payload)
}

export function remove(uuid) {
  return apiHelper(API_URL).delete(`/leads/${uuid}`)
}

export function convert(uuid, debtorCode) {
  return apiHelper(API_URL).patch(`/leads/${uuid}/convert`, { debtor_code: debtorCode })
}

export function assign(uuid, assignedTo) {
  return apiHelper(API_URL).patch(`/leads/${uuid}/assign`, { assigned_to: assignedTo })
}
